export const QA_NAME_PROFILE_ADD_NEW_MENU = 'profileAddNewMenu'
